{
  "header": {
    "title": "Session schedules",
    "description": "Start and stop charging sessions on your stations automatically at set times."
  },
  "noAccess": {
    "title": "No access",
    "description": "We couldn't load your account. Try again in a moment."
  },
  "table": {
    "title": "Schedules",
    "count": "{{count}} schedules",
    "count_one": "{{count}} schedule",
    "count_other": "{{count}} schedules",
    "searchPlaceholder": "Search schedules",
    "searchAria": "Search schedules by name",
    "stationCount": "{{count}} stations",
    "stationCount_one": "{{count}} station",
    "stationCount_other": "{{count}} stations",
    "evse": "Connector {{evse}}",
    "columns": {
      "name": "Schedule",
      "owner": "Owner",
      "stations": "Stations",
      "period": "Period",
      "schedule": "Times",
      "lastRun": "Last run",
      "status": "Status"
    },
    "empty": {
      "title": "No schedules yet",
      "description": "Create a schedule to start and stop sessions on your stations automatically."
    },
    "error": {
      "title": "Couldn't load schedules",
      "description": "Something went wrong. Try again in a moment."
    }
  },
  "action": {
    "Start": "Start",
    "Stop": "Stop"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "execStatus": {
    "Running": "Running",
    "Success": "Succeeded",
    "Partial": "Partly failed",
    "Failed": "Failed"
  },
  "period": {
    "between": "{{start}} to {{end}}",
    "from": "From {{start}}",
    "until": "Until {{end}}",
    "always": "No date limits"
  },
  "weekdays": {
    "short": {
      "0": "Sun",
      "1": "Mon",
      "2": "Tue",
      "3": "Wed",
      "4": "Thu",
      "5": "Fri",
      "6": "Sat"
    }
  },
  "lastRun": {
    "never": "Never run"
  },
  "owner": {
    "tenant": "Tenant",
    "organisation": "Organisation",
    "wholeFleet": "Whole fleet",
    "wholeFleetHint": "Any station"
  },
  "actions": {
    "new": "New schedule",
    "edit": "Edit",
    "delete": "Delete",
    "cancel": "Cancel",
    "save": "Save",
    "enable": "Enable",
    "disable": "Disable",
    "history": "Run history"
  },
  "form": {
    "addTitle": "New schedule",
    "editTitle": "Edit schedule",
    "description": "Pick the stations, the period and the times a session should start and stop. Times are Dutch local time (Europe/Amsterdam).",
    "fields": {
      "name": "Name",
      "station": "Charging station",
      "evse": "Connector",
      "periodStart": "First day",
      "periodEnd": "Last day",
      "action": "Action",
      "time": "Time",
      "recipients": "Report recipients",
      "active": "Active"
    },
    "placeholders": {
      "name": "e.g. Leiden winter 2027",
      "stationSearch": "Search a station by id, name or location and pick it to add",
      "recipients": "name@example.com, ops@example.com"
    },
    "sections": {
      "stations": "Charging stations",
      "period": "Period",
      "rules": "Start and stop times"
    },
    "stations": {
      "loading": "Loading your stations...",
      "error": "Couldn't load your stations. Try again in a moment.",
      "noResults": "No charging station found. Only stations in the list can be scheduled.",
      "selected": "{{count}} stations selected",
      "selected_one": "{{count}} station selected",
      "selected_other": "{{count}} stations selected",
      "remove": "Remove station"
    },
    "rules": {
      "add": "Add time",
      "remove": "Remove time"
    },
    "hints": {
      "evse": "The connector number on each station (1 on single-connector stations).",
      "period": "Both dates are inclusive. Leave a date empty for no limit.",
      "rules": "Each line runs every day it is ticked. Add a line per start and per stop.",
      "recipients": "Optional. Comma-separated email addresses that receive a report after every run.",
      "active": "When active, the schedule runs on its times. Turn it off to pause it without deleting."
    },
    "errors": {
      "name": "Enter a name.",
      "stations": "Select at least one charging station (at most 100).",
      "evse": "Enter a connector number of 1 or higher.",
      "period": "The last day is before the first day.",
      "rules": "Add at least one time, each with a valid time and at least one weekday.",
      "recipients": "Enter valid email addresses, or leave the field empty."
    }
  },
  "deleteDialog": {
    "title": "Delete schedule?",
    "description": "Delete \"{{name}}\" and its run history? This can't be undone.",
    "confirm": "Delete"
  },
  "executions": {
    "title": "Run history",
    "counts": "{{ok}} ok, {{skipped}} skipped, {{failed}} failed",
    "empty": {
      "title": "No runs yet",
      "description": "This schedule hasn't run yet."
    },
    "columns": {
      "when": "Scheduled for",
      "action": "Action",
      "status": "Result",
      "stations": "Stations",
      "summary": "Details"
    },
    "error": {
      "title": "Couldn't load history",
      "description": "Something went wrong. Try again in a moment."
    }
  },
  "toasts": {
    "saved": "Schedule saved.",
    "saveFailed": "Couldn't save the schedule.",
    "deleted": "Schedule deleted.",
    "deleteFailed": "Couldn't delete the schedule.",
    "toggled": "Schedule updated.",
    "toggleFailed": "Couldn't update the schedule."
  }
}
